module.exports = __webpack_public_path__ + "media/images/official/plancheck_chart_pc-dd54add7f8954dd31d5d2fd34ab063e4.jpg";